// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'

import Vue from 'vue'

import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuex from 'vuex'
import VeeValidate from 'vee-validate'
import VueAnalytics from 'vue-analytics'
import moment from 'moment'
import ToggleButton from 'vue-js-toggle-button'

import Datetime from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'

import fontawesome from '@fortawesome/fontawesome'
import {
  faEnvelope,
  faUser,
  faCar,
  faChevronDown,
  faChevronUp,
  faRoad,
  faCogs,
  faCog
} from '@fortawesome/fontawesome-free-solid'

import App from './App'
import router from './router'
import store from './store'

Vue.use(Vuex)
Vue.use(VueAxios, axios)
Vue.use(VeeValidate)
Vue.use(VueAnalytics, {
  id: 'UA-119403360-1',
  router,
  beforeFirstHit() {
    // Anonymize IP for GDPR
    Vue.$ga.set('anonymizeIp', true)
  }
})
Vue.use(Datetime)
Vue.use(ToggleButton)

Vue.prototype.moment = moment

// Build fontawesome library
fontawesome.library.add(
  faEnvelope,
  faUser,
  faCar,
  faChevronDown,
  faChevronUp,
  faRoad,
  faCogs,
  faCog
)

// Require the main SASS manifest file
require('./assets/sass/main.scss')

// Set default axios headers
axios.defaults.headers.common['Content-Type'] = 'application/json'

// Auto authententication
const token = localStorage.getItem('token')
if (token) {
  axios.defaults.headers.common.Authorization = `Token ${token}`
  store.dispatch('getUser').catch(error => {
    if (error && error.data.detail === 'Invalid token.') {
      store.dispatch('logout').then(() => router.push('/login'))
    }
  })
}

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js